const getOSKey = () => {
  const userPlatform = navigator.userAgent.toUpperCase()

  if (userPlatform.indexOf('MAC') !== -1) {
    return '⌘'
  }

  return 'Ctrl'
}

export const OS_KEY = getOSKey()
